import axios from 'axios'

export default function attendeeProfileShow (selector) {

  var vueCtrl = new Vue({
      el: selector,

      data: {
        globalChatEnabled: window.globalChatEnabled,
        currentEventAttendee: window.currentEventAttendee,
        eventAttendeeId: window.eventAttendeeId,
        blockedConnection: window.blockedConnection,
        fetchingBlockingConnection: false,
        actionListVisible: false
      },

      methods: {
        toggleActionListVisible: function () {
          this.actionListVisible = !this.actionListVisible
        },

        blockAttendee: function () {
          if (this.fetchingBlockingConnection) return;
          this.fetchingBlockingConnection = true
          var data = {blocked_event_attendee_id: this.eventAttendeeId}
          axios.post('/api/v1/blocked_connections', data)
            .then(this.handleBlockedAttendeeSuccess)
            .catch(function errorBlockAttendee (err) {
              this.$toasted.error('error blocking attendee', {duration: 4000})
            }.bind(this))
            .then(function always () {
              this.fetchingBlockingConnection = false
            }.bind(this))
        },

        handleBlockedAttendeeSuccess: function (res) {
          this.blockedConnection = Object.assign(res.data)
          if (window.globalChatController) window.globalChatController.addRoomBlockedConnectionIfExists(res.data)
        },

        unBlockAttendee: function () {
          if (this.fetchingBlockingConnection) return;
          this.fetchingBlockingConnection = true
          var data = {blocked_event_attendee_id: this.eventAttendeeId, _method: 'DELETE'}
          axios.delete(`/api/v1/blocked_connections/${this.blockedConnection.id}`, data)
            .then(this.handleUnblockAttendeeSuccess)
            .catch(function error (err) {
              this.$toasted.error('error unblocking attendee', {duration: 4000})
            }.bind(this))
            .then(function always() {
              this.fetchingBlockingConnection = false
            }.bind(this))
        },

        handleUnblockAttendeeSuccess: function (res) {
          this.blockedConnection = null
          if (window.globalChatController) window.globalChatController.removeRoomBlockedConnectionIfExists(res.data)
        }

      },

      mounted: function () {
        
      }

  })

  return vueCtrl
}